// extracted by mini-css-extract-plugin
export default {"image-compare-carousel":"image-compare-carousel-2be8","no-padding":"no-padding-f4d9","compare-container":"compare-container-0170"};